(function () {
  'use strict';

  /* @ngdoc object
   * @name heartbeat
   * @description
   *
   */
  angular
    .module('heartbeat', [
      'ui.router',
      'knalli.angular-vertxbus'
    ]);
}());
